/* LUXOTIO product-specific interactions, isolated from Zendrop global JS. */
(function () {
  'use strict';
  function ready() {
    document.querySelectorAll('[data-lxp-root]').forEach(function (root) {
      if (root.dataset.lxpReady) return;
      root.dataset.lxpReady = 'true';
      var gallery = root.querySelector('[data-lxp-gallery]');
      if (gallery) {
        var photos = Array.from(gallery.querySelectorAll('[data-lxp-photo]'));
        var thumbs = Array.from(gallery.querySelectorAll('[data-lxp-thumb]'));
        var count = gallery.querySelector('[data-lxp-counter]');
        var index = 0;
        function activate(next) {
          if (!photos.length) return;
          index = (next + photos.length) % photos.length;
          photos.forEach(function (p, i) { p.classList.toggle('is-active', i === index); });
          thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === index)); });
          if (count) count.textContent = (index + 1) + ' / ' + photos.length;
        }
        activate(0);
        thumbs.forEach(function (t) { t.addEventListener('click', function () { activate(parseInt(t.dataset.lxpThumb, 10)); }); });
        gallery.querySelectorAll('[data-lxp-gallery-dir]').forEach(function (button) {
          button.addEventListener('click', function () { activate(index + Number(button.dataset.lxpGalleryDir)); });
        });
        var stage = gallery.querySelector('.lxp-photo-main'), touchX = null, touchY = null;
        if (stage) {
          stage.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; touchY = e.changedTouches[0].clientY; }, { passive: true });
          stage.addEventListener('touchend', function (e) {
            if (touchX === null) return;
            var dx = e.changedTouches[0].clientX - touchX;
            var dy = e.changedTouches[0].clientY - touchY;
            if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) activate(index + (dx < 0 ? 1 : -1));
            touchX = touchY = null;
          }, { passive: true });
        }
      }
      var reviewSlider = root.querySelector('[data-lxp-slider]');
      if (reviewSlider) {
        var track = reviewSlider.querySelector('[data-lxp-track]');
        var dots = Array.from(reviewSlider.querySelectorAll('[data-lxp-slide]'));
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var i = Number(dot.dataset.lxpSlide);
            track.scrollTo({ left: i * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          });
        });
        track.addEventListener('scroll', function () {
          var i = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
          dots.forEach(function (dot, n) { dot.setAttribute('aria-current', String(i === n)); });
        }, { passive: true });
      }
      var form = root.querySelector('[data-lxp-form]');
      if (form) {
        var qty = form.querySelector('[data-lxp-quantity]');
        form.querySelectorAll('[data-lxp-qty-dir]').forEach(function (button) {
          button.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.lxpQtyDir)); });
        });
        var variants = form.querySelector('[data-lxp-variants]');
        var price = root.querySelector('[data-lxp-price]');
        var stickyPrice = root.querySelector('[data-lxp-sticky-price]');
        var submit = form.querySelector('[data-lxp-submit]');
        var stickySubmit = root.querySelector('[data-lxp-sticky-button]');
        if (variants) variants.addEventListener('change', function () {
          var opt = variants.options[variants.selectedIndex];
          if (price) price.textContent = opt.dataset.price;
          if (stickyPrice) stickyPrice.textContent = opt.dataset.price;
          var available = opt.dataset.available === 'true';
          submit.disabled = !available;
          submit.textContent = available ? 'AÑADIR AL CARRITO' : 'AGOTADO';
          if (stickySubmit) { stickySubmit.disabled = !available; stickySubmit.textContent = submit.textContent; }
        });
        if (stickySubmit) {
          stickySubmit.addEventListener('click', function () { if (!submit.disabled) { if (form.requestSubmit) form.requestSubmit(submit); else submit.click(); } });
        }
        var sticky = root.querySelector('[data-lxp-sticky]');
        if (sticky && window.IntersectionObserver) {
          var purchaseFormRow = root.querySelector('[data-lxp-main-formrow]');
          if (purchaseFormRow) {
            new IntersectionObserver(function (entries) {
              sticky.classList.toggle('is-shown', !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0);
            }, { threshold: 0 }).observe(purchaseFormRow);
          }
        }
      }
      var range = root.querySelector('[data-lxp-range]');
      var compare = root.querySelector('[data-lxp-compare]');
      if (range && compare) range.addEventListener('input', function () { compare.style.setProperty('--lxp-split', range.value + '%'); range.setAttribute('aria-valuetext', range.value + '% de imagen natural'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', ready);
})();
